import { render, staticRenderFns } from "./WachtOpClient.vue?vue&type=template&id=35cf0ad8&scoped=true&"
import script from "./WachtOpClient.vue?vue&type=script&lang=js&"
export * from "./WachtOpClient.vue?vue&type=script&lang=js&"
import style0 from "./WachtOpClient.vue?vue&type=style&index=0&id=35cf0ad8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35cf0ad8",
  null
  
)

export default component.exports